import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { hasPagePermission } from "./hasPagePermission";

export default function RequirePermission({ permission, children }) {
  const { permissions } = useUser();

  const allowed = hasPagePermission(permissions, permission);
  //if (!hasPagePermission(permissions, permission)) {

  if (!allowed) {
    return <Navigate to="/login" replace />;
  }

  return children;
}